import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#arrow-left_svg__a)">
      <path
        fill="currentColor"
        d="M23 11H3.41l7.3-7.29A.996.996 0 1 0 9.3 2.3L.29 11.29a1 1 0 0 0 0 1.42l9 9c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41L3.41 13H23c.55 0 1-.45 1-1s-.45-1-1-1"
      />
    </g>
    <defs>
      <clipPath id="arrow-left_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgArrowLeft;
